import React,{useEffect} from 'react'
import { Link,useNavigate } from 'react-router-dom'
import Logo from '../../assets/images/logo.png'
import StudentImg from '../../assets/images/login-students.png'
import ResetPasswordForm from '../../components/Auth/ResetPasswordForm'


const ResetPassowrdPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if(sessionStorage.getItem('token')){
            navigate('/student/dashboard');
        }
    },[])

  return (
    <div className="login_page ">
        <div className="container">
            <div className="row login_register_form justify-content-between align-items-center">
                <div className="col-lg-12">
                    
                </div>
                <div className="col-lg-5">
                    <div className="login_left">
                        <img src={Logo} className="img-fluid" alt="Logo"/>
                        {/* <h1>Welcome Student</h1>*/}
                        <h2>Reset Password</h2> 

                        <p>Back to Login ? <Link to="/login" className="text-decoration-none text-primary fw-bold" title="Back to Login">Login</Link></p>
                        <ResetPasswordForm/>
                    </div>
                </div>

                <div className="col-lg-6 d-none d-lg-block align-self-stretch position-relative">
                    <div className="login_student_col position-relative">
                        <img src={StudentImg} alt="Student pic"/>
                        <h2>Welcome to ALLEN Overseas</h2>
                        <p>Your Partner in Education</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default ResetPassowrdPage